<template>
  <main class="contenedor">
    <form @submit.prevent="onSubmit">
      <h4 class="text-center" v-if="!isSigning">SEPA Method</h4>
      <hr />
      <vue-form-generator
        ref="vfg"
        :schema="schema"
        :model="this.model"
        :options="formOptions"
      ></vue-form-generator>
      <hr />
      <div class="vue-form-generator">
        <div class="form-group valid field-submit col-sm-12">
          <div class="field-wrap float-right">
            <input id="" type="submit" value="Save" />
          </div>
        </div>
      </div>
    </form>
  </main>
</template>
<script>
import Vue from "vue";

import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";
import Header from "@/components/Header.vue";
import { billingsService, proporsalService } from "@/_services";
import { mapMutations, mapState } from "vuex/dist/vuex.common.js";

export default {
  props: {
    // selectedMethod: {
    //   type: Object,
    // },
    anonymousType: {
      type: Boolean,
      default: false,
    },

    profileData: {
      type: Object,
    },
    userId: {
      type: String,
      default: "",
    },
    isSigning: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    var self = this;
    return {
      selectedMethod: {},
      schema: {
        fields: [
          {
            type: "input",
            inputType: "hidden",
            model: "id",
            readonly: true,
            featured: false,
            disabled: true,
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.nameonbankaccount"),
            model: "bank_account_name",
            readonly: false,
            required: true,
            disabled: false,
            min: 5,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.iban"),
            model: "iban",
            readonly: false,
            required: true,
            disabled: false,
            min: 15,
            max: 34,
            validator: (value, field, model) => {
              if (!value || value.length === 0) {
                return [this.$t("lang.label.required")];
              }
              if (value.includes(" ")) {
                return "Spaces are not allowed";
              }
              if (value.length < 15) {
                return "Minimum 15 characters required";
              }
              if (value.length > 34) {
                return "Maximum 34 characters allowed";
              }
              return [];
            },
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.swiftbic"),
            model: "swift_bic",
            readonly: false,
            required: true,
            disabled: false,
            min: 5,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.signatoryname"),
            model: "signatory_name",
            readonly: false,
            disabled: false,
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.addressline1"),
            model: "address_line_1",
            readonly: false,
            required: true,
            min: 5,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.addressline2"),
            model: "address_line_2",
            readonly: false,
            required: false,
            disabled: false,
            min: 5,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.postalcode"),
            model: "postal_code",
            readonly: false,
            required: true,
            min: 4,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.city"),
            model: "city",
            readonly: false,
            required: true,
            min: 4,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "switch",
            label: this.$t("lang.label.markasprincipal"),
            model: "default",
            textOn: this.$t("lang.label.principal"),
            textOff: this.$t("lang.label.no"),
            valueOn: "1",
            valueOff: "0",
            default: "1",
            visible() {
              return !self.isSigning;
            },
            styleClasses: "col-md-3",
          },
        ],
      },

      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
      },
    };
  },
  components: {
    Header,
    "vue-form-generator": VueFormGenerator.component,
  },
  created() {
    this.selectedMethod.default = "1";
    this.selectedMethod.postal_code =
      this.profileData.code_postal != undefined
        ? this.profileData.code_postal
        : "";
    this.selectedMethod.address_line_1 =
      this.profileData.address != undefined ? this.profileData.address : "";
    this.selectedMethod.city =
      this.profileData.city != undefined ? this.profileData.city : "";
    if (this.anonymousType) {
      this.selectedMethod.user_id = this.userId;
      this.selectedMethod.role_id = 4;
    }
  },
  computed: {
    model() {
      return this.selectedMethod;
    },
    ...mapState("billings", {
      loadingBankAccount: (state) => state.loading,
    }),
  },
  methods: {
    ...mapMutations("billings", {
      startLoading: "startLoading",
      finishLoading: "finishLoading",
    }),
    onSubmit() {
      if (this.$refs.vfg.errors.length > 0) {
        $event.preventDefault();
        this.$swal({
          type: "error",
          title: this.$t("lang.label.error"),
          text: this.$t("lang.label.checkdeerrormessagesintheformandtryagain"),
          showConfirmButton: true,
        });
      } else {
        this.$modal.hide("confirm");

        if (this.anonymousType) {
          this.startLoading();
          this.selectedMethod.profileData = this.profileData;
          this.selectedMethod.isSigning = this.isSigning;

          proporsalService
            .setSepaPaymentMethod(this.selectedMethod)
            .then((response) => {
              if (response == "ok") {
                this.$swal({
                  type: "success",
                  title: this.$t("lang.label.great"),
                  text: this.$t("lang.label.paymentmethodaddedsuccesfully"),
                  showConfirmButton: false,
                  timer: 7000,
                });
                window.location.reload();
              } else {
                this.$swal({
                  type: "error",
                  title: this.$t("lang.label.error"),
                  html: this.$t("lang.general.error"),
                  showConfirmButton: false,
                  timer: 9000,
                });
              }
            })
            .finally(() => {
              this.finishLoading();
            });
          return;
        }

        if (!this.anonymousType && this.isSigning) {
          this.selectedMethod.url = this.$route.path;
          this.selectedMethod.profileData = this.profileData;
          this.selectedMethod.isSigning = this.isSigning;

          billingsService
            .saveSepaPaymentMethod(this.selectedMethod)
            .then((response) => {
              if (response.orderCode !== undefined) {
                console.log("order code activado")
                window.location.href = response.orderCode;
              }
              const { dispatch } = this.$store;
              if (response == "ok") {
                return dispatch("authentication/refreshToken").then(() => {
                  // let conditionPayment = "ok";
                  // if (response != "ok") {
                  //   conditionPayment = "error";
                  // }
                    this.$swal({
                      type: "success",
                      title: this.$t("lang.label.great"),
                      text: this.$t("lang.label.paymentmethodaddedsuccesfully"),
                      showConfirmButton: false,
                      timer: 7000,
                    });
                    this.$router.push("/dashboard");
                });
              } 
            })
            .catch(() =>{
              this.$swal({
                icon: "error",
                title: this.$t("lang.label.error"),
                html: this.$t("lang.general.error"),
                showConfirmButton: false,
                timer: 9000,
              });
            })
            .finally((response) => {
              this.$emit("refreshPaymentMethods");
            });
          return;
        } else {
          this.$swal({
            type: "warning",
            title: this.$t("lang.label.areyousure"),
            text: this.$t("lang.label.youaregoingtoaddanewpaymentmethod"),
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33a2c",
            confirmButtonText: this.$t("lang.button.yes"),
            cancelButtonText: this.$t("lang.button.cancel"),
          }).then((result) => {
            if (result.value) {
              this.selectedMethod.url = this.$route.path;
              this.selectedMethod.profileData = this.profileData;
              this.selectedMethod.isSigning = this.isSigning;

              billingsService
                .saveSepaPaymentMethod(this.selectedMethod)
                .then((response) => {
                  if (response.orderCode !== undefined) {
                    window.location.href = response.orderCode;
                  }
                  // else {
                  //   this.$swal({
                  //     type: "error",
                  //     title: this.$t("lang.label.error"),
                  //     text: 'ERROR',
                  //     showConfirmButton: true,
                  //   });
                  //     return;
                  //   }
                  if (response == "ok") {
                    this.$swal({
                      type: "success",
                      title: this.$t("lang.label.great"),
                      text: this.$t("lang.label.paymentmethodaddedsuccesfully"),
                      showConfirmButton: false,
                      timer: 7000,
                    });
                    window.location.reload();
                  } else {
                    this.$swal({
                      type: "error",
                      title: this.$t("lang.label.error"),
                      html: this.$t("lang.general.error"),
                      showConfirmButton: false,
                      timer: 9000,
                    });
                  }
                  this.$modal.hide("sepaPaymentMethod");
                })
                .then((response) => {
                  this.$emit("refreshPaymentMethods");
                });
            }
          });
        }
      }
    },
  },
};
</script>
